import { useMemo } from "react";
import { Helmet } from "react-helmet-async";

export type TitleProps = {
  children: string;
  template?: "blog" | "default" | "docs" | "settings" | "statusPage";
};

export default function Title({ children, template = "default" }: TitleProps) {
  const title = useMemo(() => {
    return ({
      blog: `${children} | WebGazer Blog`,
      default: `${children} | WebGazer`,
      docs: `${children} | WebGazer Docs`,
      settings: `Settings - ${children} | WebGazer`,
      statusPage: `${children}`,
    })[template];
  }, [children, template]);

  return (
    <>
      <title>{title}</title>

      <Helmet>
        <meta content={title} property="og:title" />
      </Helmet>
    </>
  );
}
